import { DownloadAppModule } from './DownloadApp/DownloadAppModule';

export default DownloadAppModule;